<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title" style="padding: 20px  0 0 0;">Danielle</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-4"><a href="#/text/ch004#introduction">Introduction</a></li>
<li id="toc-li-5"><a href="#/text/ch005#together-at-last">Together at Last</a></li>
<li id="toc-li-6"><a href="#/text/ch006#an-unexpected-joy">An Unexpected Joy</a></li>
<li id="toc-li-7"><a href="#/text/ch007#our-hearts-are-so-full">Our Hearts Are So Full</a></li>
<li id="toc-li-8"><a href="#/text/ch008#growing-in-faith">Growing in Faith</a></li>
<li id="toc-li-9"><a href="#/text/ch009#then-there-were-two">Then There Were Two</a></li>
<li id="toc-li-10"><span href="#/text/ch010#going-home-a-family-of-five" title="Link target outside of Sample">Going Home: A Family of Five</span></li>
<li id="toc-li-11"><span href="#/text/ch011#getting-settled-in-our-new-home" title="Link target outside of Sample">Getting Settled in Our New Home</span></li>
<li id="toc-li-12"><span href="#/text/ch012#valley-of-tears" title="Link target outside of Sample">Valley of Tears</span></li>
<li id="toc-li-13"><span href="#/text/ch013#strength-to-endure" title="Link target outside of Sample">Strength to Endure</span></li>
<li id="toc-li-14"><span href="#/text/ch014#faith-hope-and-love" title="Link target outside of Sample">Faith, Hope, and Love</span></li>
<li id="toc-li-15"><span href="#/text/ch015#growing-in-faith-1" title="Link target outside of Sample">Growing in Faith</span></li>
<li id="toc-li-16"><span href="#/text/ch016#a-gift-from-god" title="Link target outside of Sample">A Gift from God</span></li>
<li id="toc-li-17"><span href="#/text/ch017#others-getting-to-know-danielle" title="Link target outside of Sample">Others Getting to Know Danielle</span></li>
<li id="toc-li-18"><span href="#/text/ch018#other-setbacks" title="Link target outside of Sample">Other Setbacks</span></li>
<li id="toc-li-19"><span href="#/text/ch019#summer-of-fun" title="Link target outside of Sample">Summer of Fun</span></li>
<li id="toc-li-20"><span href="#/text/ch020#relapse" title="Link target outside of Sample">Relapse</span></li>
<li id="toc-li-21"><span href="#/text/ch021#danielles-seventh-birthday" title="Link target outside of Sample">Danielle’s Seventh Birthday</span></li>
<li id="toc-li-22"><span href="#/text/ch022#camp-watonga" title="Link target outside of Sample">Camp Watonga</span></li>
<li id="toc-li-23"><span href="#/text/ch023#sharing-in-the-eucharist-regularly" title="Link target outside of Sample">Sharing in the Eucharist Regularly</span></li>
<li id="toc-li-24"><span href="#/text/ch024#finding-a-donor" title="Link target outside of Sample">Finding a Donor</span></li>
<li id="toc-li-25"><span href="#/text/ch025#another-means-of-suffering" title="Link target outside of Sample">Another Means of Suffering</span></li>
<li id="toc-li-26"><span href="#/text/ch026#a-perfect-match" title="Link target outside of Sample">A Perfect Match</span></li>
<li id="toc-li-27"><span href="#/text/ch027#come-holy-spirit" title="Link target outside of Sample">Come Holy Spirit</span></li>
<li id="toc-li-28"><span href="#/text/ch028#trip-to-disney-world" title="Link target outside of Sample">Trip to Disney World</span></li>
<li id="toc-li-29"><span href="#/text/ch029#the-bone-marrow-transplant" title="Link target outside of Sample">The Bone Marrow Transplant</span></li>
<li id="toc-li-30"><span href="#/text/ch030#going-to-her-heavenly-home" title="Link target outside of Sample">Going to Her Heavenly Home</span></li>
<li id="toc-li-31"><span href="#/text/ch031#our-loss-is-his-gain" title="Link target outside of Sample">Our Loss Is His Gain</span></li>
<li id="toc-li-32"><span href="#/text/ch032#preparing-for-her-union-with-christ" title="Link target outside of Sample">Preparing for Her Union With Christ</span></li>
<li id="toc-li-33"><span href="#/text/ch033#death-is-not-the-end" title="Link target outside of Sample">Death Is Not the End</span></li>
<li id="toc-li-34"><span href="#/text/ch034#thoughts-from-dad" title="Link target outside of Sample">Thoughts From Dad</span></li>
<li id="toc-li-35"><span href="#/text/ch035#epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li id="toc-li-36"><span href="#/text/ch036#litany-in-honor-of-the-little-therese" title="Link target outside of Sample">Litany in Honor of the Little Therese</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?b1deeb26